import { useNavigate } from 'react-router-dom';
import { Plus } from '@phosphor-icons/react';
import { Button } from '@/components/ui-kit/button';

export const CampaignsCreateButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      type="button"
      className="h-10 gap-2 rounded-md bg-primary-600 px-4 font-medium text-white hover:bg-primary-700"
      onClick={() => navigate('/campaigns/create-campaign')}
    >
      <Plus className="size-4" aria-hidden />
      New campaign
    </Button>
  );
};
